/*
  for convenience, you can also set environment variable APP_BACKEND_HOST in .env file in project root directory
  this is ignored by git and is persistent
  NOTE: changes to .env file will require dev server restart
*/

export const HOST = 
  process.env.APP_BACKEND_HOST ?? "https://phoenix-backend-production.com/api";

export const DOCUSIGN_HOST =
  process.env.DOCUSIGN_HOST ?? "https://c-papyrus.com";

// New Relic Browser — values injected from Azure DevOps Prod library only
export const NEW_RELIC_APP_ID = process.env.NEW_RELIC_APP_ID;
export const NEW_RELIC_LICENSE_KEY = process.env.NEW_RELIC_LICENSE_KEY;
